import {encode} from "./lib-common";
class Licenses{
    constructor(headers){
        this.headers=headers
    }
    async fix(id,license){
        let {library,version}=license;
        if(!version || !version.length) version = "--";
		const url='/api/v1/licenses/library/'+encode(library.language)+'/'+encode(library.name)+'/'+encode(version)+"/"+id;
        try{
            const licenseFixRequest= await fetch(url, {
				method:'POST', 
				headers: {
					...this.headers, "Content-Type":"text/plain"
				}
            })
            if(licenseFixRequest.status!==200) throw await licenseFixRequest.json();
            return
        }
		catch(e){
            throw e
		}
    }
}

export default Licenses